// Self eradicating component for rendering multiple elements
const Aux = (props) => props.children;

export default Aux;



// WEBPACK FOOTER //
// ./src/components/_Aux.js